import { AuthService} from 'src/services';
import {  AuthenticationResultDTO } from 'src/services/generated/api.generated.v1';
import { ActionTree, Commit } from 'vuex';
import { StateInterface } from '../index';
import { UserStateInterface } from './state';

const authService = new AuthService();

const actions: ActionTree<UserStateInterface, StateInterface> = {
  async logout({ commit }: { commit: Commit }) {

    await authService.Logout();

    const emptyUser = new AuthenticationResultDTO();

    commit('updateUserState', emptyUser);
  },

  updateActiveDealerAccount({ commit }: { commit: Commit }, dealerUid : string): void {
    commit('updateActiveDealerAccount', dealerUid);
  } 
};

export default actions;
